// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  duration: 0,
  durationStartTimeStamp: 0,
  durationFlag: false,
};

// Redux Slice for Asssess
const assessSlice = createSlice({
  name: "assess",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    startDuration(state, { payload }) {
      if (state.durationFlag) {
        let startdateObj = new Date();
        return {
          ...state,
          durationStartTimeStamp: startdateObj.getTime(),
        };
      }
    },
    stopDuration(state, { payload }) {
      if (state.durationFlag) {
        let enddateObj = new Date();
        let endtimestamp = enddateObj.getTime();
        let duration = 0;
        if (state.durationStartTimeStamp != 0) {
          duration =
            +endtimestamp -
            +state.durationStartTimeStamp +
            Number(state.duration);
        }

        return {
          ...state,
          durationStartTimeStamp: 0,
          duration: duration,
        };
      }
    },
    setDurationFlag(state, { payload }) {
      return {
        ...state,
        durationFlag: payload,
      };
    },
  },
});

export const assessSliceActions = assessSlice.actions;

export default assessSlice;
